import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import apple_btn from "/public/img/apple_btn.png";
import built_in_crypto from "/public/img/built-in-crypto.png";
import check_3 from "/public/img/check-3.png";
import gPlay_btn from "/public/img/gPlay_btn.png";

const BuiltInCrypto = () => {
  return (
    <section className="what-you-need index10 second">
      <div className="overlay pt-120 pb-120">
        <div className="container cus-mar">
          <div className="main-content">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="content-area">
                  <h2>Crypto moves with the same guardrails</h2>
                  <p>
                    Conversions and on-chain transfers inherit the same policy
                    engine as fiat: velocity limits, address allow lists, and
                    manual approvals when a withdrawal looks unusual.
                  </p>
                  <ul className="feature">
                    <li>
                      <div className="icon">
                        <Image src={check_3} alt="icon" />
                      </div>
                      Wallet whitelisting and cooldowns
                    </li>
                    <li>
                      <div className="icon">
                        <Image src={check_3} alt="icon" />
                      </div>
                      On-chain transaction signing alerts
                    </li>
                    <li>
                      <div className="icon">
                        <Image src={check_3} alt="icon" />
                      </div>
                      Insurance-backed custody partners
                    </li>
                  </ul>
                  <div className="app-market">
                    <Link href="#">
                      <Image src={gPlay_btn} alt="App Store" />
                    </Link>
                    <Link href="#">
                      <Image src={apple_btn} alt="App Store" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex justify-content-center align-items-center">
                <div className="img-area text-center">
                  <Image src={built_in_crypto} alt="image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltInCrypto;
